// extracted by mini-css-extract-plugin
module.exports = {"toast":"styles-module__toast___1I9--"};